import { SimilarLaboratoriesPageQueryDocument } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getSimilarLaboratoriesByLaboratoryId(laboratoryId: string, page: number = 1) {
  const { data } = await ApolloClient.query({
    query: SimilarLaboratoriesPageQueryDocument,
    variables: { laboratoryId, page },
  });

  return data?.similarLaboratories;
}
